export default {
  baseUrl: 'https://qa-apit9.lqfast.com',
  lqBaseUrl: 'https://t9bsjj-qa.lqfast.com',
  lqAssetsServeUrl: 'https://lq-shangcheng.obs.cn-east-3.myhuaweicloud.com/t9bs'
}
